/* Hairstreaq PDP — vanilla JS (no framework)
   Bundle color-quantity picker, AJAX ATC w/ redirect,
   sticky/footer CTA scroll-to-buy-box, gallery, before/after, FAQ, video, marquee. */
(function () {
  'use strict';

  if (window.__HairstreaqPDPBooted) return;
  window.__HairstreaqPDPBooted = true;

  var state = (window.HairstreaqPDP = window.HairstreaqPDP || {
    bundle: 2,
    colorCounts: {},   // color key (string) -> count (integer)
    bundles: null,
    variants: [],      // [{variantId, color, hex, isDefault}]
    listeners: [],
  });

  state.subscribe = function (fn) { state.listeners.push(fn); };
  function emit() { state.listeners.forEach(function (fn) { try { fn(state); } catch (e) {} }); }

  function getTotalCount() {
    return Object.keys(state.colorCounts).reduce(function (sum, id) {
      return sum + (state.colorCounts[id] || 0);
    }, 0);
  }
  state.getTotalCount = getTotalCount;

  function getColorKey(v) {
    if (!v) return '';
    var color = String(v.color || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return String(v.variantId || '') + '::' + color;
  }
  state.getColorKey = getColorKey;

  state.addColor = function (key) {
    var id = String(key);
    if (getTotalCount() >= state.bundle) return;
    state.colorCounts[id] = (state.colorCounts[id] || 0) + 1;
    emit();
  };

  state.removeColor = function (key) {
    var id = String(key);
    if (!state.colorCounts[id]) return;
    state.colorCounts[id]--;
    if (state.colorCounts[id] <= 0) delete state.colorCounts[id];
    emit();
  };

  state.setBundle = function (n) {
    state.bundle = n;
    state.colorCounts = {};
    state.colorError = '';
    emit();
  };

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
  state.fmt = fmt;

  // A page can carry more than one buy box (e.g. the classic Buy Box plus HS
  // Buy Box Scroll) with all but one hidden via CSS. Hidden ones must stay out
  // of the shared state, otherwise whichever initialises last owns the bundle
  // data the sticky ATC mirrors.
  function isHidden(el) {
    if (!el) return true;
    if (el.offsetParent === null && window.getComputedStyle(el).position !== 'fixed') return true;
    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
  state.isHidden = isHidden;

  function activeBuyBox() {
    var boxes = document.querySelectorAll('[data-hs-buy-box]');
    for (var i = 0; i < boxes.length; i++) {
      if (!isHidden(boxes[i])) return boxes[i];
    }
    return boxes[0] || null;
  }
  state.activeBuyBox = activeBuyBox;

  // ─── Smooth scroll to buy-box ─────────────────────────────────────────────
  function scrollToBuyBox() {
    var el = activeBuyBox();
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var y = window.scrollY + rect.top - 20;
    window.scrollTo({top: y, behavior: 'smooth'});
  }
  state.scrollToBuyBox = scrollToBuyBox;

  // ─── Marquee ──────────────────────────────────────────────────────────────
  function initMarquee(el) {
    var track = el.querySelector('.hs-marquee-track');
    if (!track || !track.firstElementChild) return;
    track.appendChild(track.firstElementChild.cloneNode(true));
  }

  // ─── Gallery ──────────────────────────────────────────────────────────────
  function initGallery(el) {
    var counter = el.querySelector('[data-hs-gallery-counter]');
    var thumbs = el.querySelectorAll('[data-hs-thumb]');
    var slides = el.querySelectorAll('[data-hs-slide]');
    var main = el.querySelector('[data-hs-gallery-main]');
    var current = 0;
    function setActive(i) {
      if (!slides.length) return;
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      current = i;
      slides.forEach(function (s) { s.style.display = ''; });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      if (counter) {
        var p = function (n) { return n < 10 ? '0' + n : '' + n; };
        counter.textContent = p(i + 1) + ' / ' + p(slides.length);
      }
    }
    function show(i) {
      setActive(i);
      if (main && slides[i]) main.scrollTo({left: slides[i].offsetLeft, behavior: 'smooth'});
    }
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { show(idx); }); });
    if (main && slides.length > 1) {
      var scrollTimer = null;
      main.addEventListener('scroll', function () {
        if (scrollTimer) window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var width = main.clientWidth || 1;
          setActive(Math.round(main.scrollLeft / width));
        }, 40);
      }, {passive: true});
    }
    setActive(0);
  }

  // ─── Before/After slider ──────────────────────────────────────────────────
  function initBeforeAfter(el) {
    var frame = el.querySelector('[data-hs-ba-frame]');
    var before = el.querySelector('[data-hs-ba-before]');
    var handle = el.querySelector('[data-hs-ba-handle]');
    if (!frame || !before || !handle) return;
    function setSlide(pct) {
      pct = Math.max(2, Math.min(98, pct));
      before.style.clipPath = 'polygon(0 0, ' + pct + '% 0, ' + pct + '% 100%, 0 100%)';
      handle.style.left = pct + '%';
    }
    setSlide(50);
    function p(e) {
      if (e.type === 'pointermove' && e.buttons !== 1) return;
      var r = frame.getBoundingClientRect();
      setSlide(((e.clientX - r.left) / r.width) * 100);
    }
    frame.addEventListener('pointerdown', function (e) {
      p(e); try { frame.setPointerCapture(e.pointerId); } catch (err) {}
    });
    frame.addEventListener('pointermove', p);
  }

  // ─── FAQ ──────────────────────────────────────────────────────────────────
  function initFaq(el) {
    var items = el.querySelectorAll('[data-hs-faq-item]');
    items.forEach(function (item) {
      var q = item.querySelector('[data-hs-faq-q]');
      if (!q) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });
    if (items[0]) items[0].classList.add('is-open');
  }

  // ─── Video tap-to-play ────────────────────────────────────────────────────
  function initVideo(el) {
    var frame = el.querySelector('[data-hs-video-frame]');
    var iframe = el.querySelector('[data-hs-video-iframe]');
    var nativeVideo = el.querySelector('[data-hs-native-video]');
    var play = el.querySelector('[data-hs-video-play]');
    var poster = el.querySelector('[data-hs-video-poster]');
    if (!frame) return;
    frame.addEventListener('click', function () {
      if (iframe && iframe.dataset.src && !iframe.src) iframe.src = iframe.dataset.src;
      if (nativeVideo && nativeVideo.paused) nativeVideo.play().catch(function () {});
      if (poster) poster.style.display = 'none';
      if (play) play.style.display = 'none';
    });
  }

  // ─── Buy Box ──────────────────────────────────────────────────────────────
  function initBuyBox(el) {
    // Parse defensively: a stray apostrophe in a bundle label would otherwise
    // throw here and leave the section with no click handlers at all.
    function parseData(attr) {
      try {
        return JSON.parse(el.getAttribute(attr) || '[]') || [];
      } catch (err) {
        console.error('Hairstreaq buy box: could not parse ' + attr, err);
        return [];
      }
    }
    var bundlesData = parseData('data-hs-bundles');
    var variantsData = parseData('data-hs-variants');
    state.bundles = bundlesData;
    state.variants = variantsData.map(function (v) {
      v.key = getColorKey(v);
      return v;
    });
    state.colorCounts = {};
    state.colorError = '';

    // Initial bundle from "is-best" card
    var initialBundleCard = el.querySelector('[data-hs-bundle-card].is-selected');
    if (initialBundleCard) {
      state.bundle = parseInt(initialBundleCard.getAttribute('data-bundle-id'), 10) || state.bundle;
    }

    // Bundle card clicks
    var bundleCards = el.querySelectorAll('[data-hs-bundle-card]');
    var bundleScroller = el.querySelector('.hs-buy-box-scroll .hs-bundle-list');
    var bundleWasDragged = false;
    function scrollSelectedBundle(behavior) {
      var selected = el.querySelector('[data-hs-bundle-card].is-selected');
      if (!selected) return;
      var scroller = selected.closest('.hs-bundle-list');
      var item = selected.closest('.hs-bundle-wrap') || selected;
      if (!scroller || !item || scroller.scrollWidth <= scroller.clientWidth) return;
      var left = item.offsetLeft - (scroller.clientWidth - item.offsetWidth) / 2;
      scroller.scrollTo({left: Math.max(0, left), behavior: behavior || 'smooth'});
    }
    if (bundleScroller) {
      var dragActive = false;
      var dragStartX = 0;
      var dragStartLeft = 0;
      var dragMoved = false;
      bundleScroller.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button > 0) return;
        dragActive = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragStartLeft = bundleScroller.scrollLeft;
        bundleScroller.classList.add('is-dragging');
      });
      bundleScroller.addEventListener('pointermove', function (e) {
        if (!dragActive) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 4) {
          if (!dragMoved) {
            try { bundleScroller.setPointerCapture(e.pointerId); } catch (err) {}
          }
          dragMoved = true;
          bundleWasDragged = true;
          bundleScroller.scrollLeft = dragStartLeft - dx;
          e.preventDefault();
        }
      });
      function endBundleDrag() {
        if (!dragActive) return;
        dragActive = false;
        bundleScroller.classList.remove('is-dragging');
        if (dragMoved) {
          window.setTimeout(function () { bundleWasDragged = false; }, 80);
        }
      }
      bundleScroller.addEventListener('pointerup', endBundleDrag);
      bundleScroller.addEventListener('pointercancel', endBundleDrag);
      bundleScroller.addEventListener('lostpointercapture', endBundleDrag);
    }
    bundleCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (bundleWasDragged) {
          e.preventDefault();
          return;
        }
        var id = parseInt(card.getAttribute('data-bundle-id'), 10);
        state.setBundle(id);
        scrollSelectedBundle('smooth');
      });
    });

    // Color tile clicks (delegated). Tapping the tile adds that color; tapping
    // the minus control removes it.
    el.addEventListener('click', function (e) {
      var tile = e.target.closest && e.target.closest('[data-hs-color-tile]');
      if (!tile) return;
      var key = tile.getAttribute('data-color-key');
      var isMinus = e.target.closest('[data-hs-color-minus]');
      if (isMinus) {
        e.preventDefault();
        e.stopPropagation();
        state.removeColor(key);
      } else {
        state.addColor(key);
      }
      state.colorError = '';
    });

    // Render reaction
    function render() {
      // Bundle highlight
      bundleCards.forEach(function (card) {
        var id = parseInt(card.getAttribute('data-bundle-id'), 10);
        card.classList.toggle('is-selected', id === state.bundle);
      });

      // Color tiles
      var total = getTotalCount();
      if (total >= state.bundle) state.colorError = '';
      el.querySelectorAll('[data-hs-color-tile]').forEach(function (tile) {
        var key = tile.getAttribute('data-color-key');
        var count = state.colorCounts[key] || 0;
        tile.classList.toggle('has-count', count > 0);
        var countEl = tile.querySelector('[data-hs-color-count]');
        if (countEl) countEl.textContent = count;
        var plusBtn = tile.querySelector('[data-hs-color-plus]');
        if (plusBtn) plusBtn.classList.toggle('is-dim', total >= state.bundle);
      });

      // Bundle qty label in preview
      el.querySelectorAll('[data-hs-bundle-qty]').forEach(function (span) {
        span.textContent = state.bundle;
      });

      // Preview selected bundle colors
      var slotsEl = el.querySelector('[data-hs-bundle-slots]');
      if (slotsEl) {
        slotsEl.innerHTML = '';
        var selectedCount = 0;
        state.variants.forEach(function (v) {
          var c = state.colorCounts[v.key] || 0;
          if (c <= 0) return;
          selectedCount += c;
          var item = document.createElement('div');
          item.className = 'hs-include-pill';
          var dot = document.createElement('span');
          dot.className = 'hs-include-dot';
          dot.style.background = v.hex;
          var text = document.createElement('span');
          text.className = 'hs-include-text';
          text.textContent = c > 1 ? v.color + ' x' + c : v.color;
          item.appendChild(dot);
          item.appendChild(text);
          slotsEl.appendChild(item);
        });
        for (var i = selectedCount; i < state.bundle; i++) {
          var dot = document.createElement('div');
          dot.className = 'hs-slot-dot is-empty';
          slotsEl.appendChild(dot);
        }
      }

      var errorEl = el.querySelector('[data-hs-color-error]');
      if (errorEl) {
        if (state.colorError) {
          errorEl.textContent = state.colorError;
          errorEl.hidden = false;
        } else {
          errorEl.textContent = '';
          errorEl.hidden = true;
        }
      }

      // Price
      var b = (state.bundles || []).find(function (x) { return x.id === state.bundle; });
      if (b) {
        var pm = el.querySelector('[data-hs-price-main]');
        var pc = el.querySelector('[data-hs-price-compare]');
        var ps = el.querySelector('[data-hs-price-save]');
        if (pm) pm.textContent = fmt(b.totalCents);
        if (pc) {
          if (b.compareCents > b.totalCents) {
            pc.style.display = '';
            pc.textContent = fmt(b.compareCents);
          } else {
            pc.style.display = 'none';
          }
        }
        if (ps) {
          ps.textContent = b.saveLabel ? b.saveLabel.replace(/^Save /, 'You save ') : '';
        }

        // Sticky ATC mirror
        var stickyMini = document.querySelector('.hs-sticky-atc .swatch-mini');
        if (stickyMini) {
          var firstHex = null;
          state.variants.forEach(function (v) {
            if (!firstHex && state.colorCounts[v.key] > 0) firstHex = v.hex;
          });
          stickyMini.style.background = firstHex || 'var(--hs-bg-cream)';
        }
        var stickyLabel = document.querySelector('[data-hs-sticky-label]');
        if (stickyLabel) stickyLabel.textContent = b.label;
        var stickyTotal = document.querySelector('[data-hs-sticky-total]');
        if (stickyTotal) {
          stickyTotal.textContent = b.showEachPrice
            ? fmt(b.unitCents) + ' each'
            : fmt(b.totalCents);
        }
        var stickySave = document.querySelector('[data-hs-sticky-save]');
        if (stickySave) {
          stickySave.textContent = b.saveLabel
            ? (b.showEachPrice ? '(' + b.saveLabel + ')' : b.saveLabel.replace(/^Save /, 'You save '))
            : '';
          stickySave.style.display = b.saveLabel ? '' : 'none';
        }
      }
    }

    state.subscribe(render);
    render();
    window.setTimeout(function () { scrollSelectedBundle('auto'); }, 80);

    // ATC button
    var atcBtn = el.querySelector('[data-hs-atc]');
    atcBtn && atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(atcBtn, el);
    });
  }

  function addToCart(btn, buyBoxEl) {
    var selectedTotal = getTotalCount();
    if (selectedTotal < state.bundle) {
      var remaining = state.bundle - selectedTotal;
      state.colorError = 'Choose ' + remaining + ' more ' + (remaining === 1 ? 'brush color' : 'brush colors') + ' to complete your ' + state.bundle + '-pack.';
      emit();
      var errorEl = buyBoxEl && buyBoxEl.querySelector('[data-hs-color-error]');
      if (errorEl) errorEl.scrollIntoView({behavior: 'smooth', block: 'center'});
      return;
    }

    var items = [];
    var countsByVariant = {};
    state.variants.forEach(function (v) {
      var c = state.colorCounts[v.key] || 0;
      if (c > 0 && v.variantId) {
        countsByVariant[String(v.variantId)] = (countsByVariant[String(v.variantId)] || 0) + c;
      }
    });
    Object.keys(countsByVariant).forEach(function (id) {
      items.push({id: parseInt(id, 10), quantity: countsByVariant[id]});
    });

    if (!items.length) {
      state.colorError = 'Choose your brush colors to complete your bundle.';
      emit();
      return;
    }

    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: items}),
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = origText || 'Add to cart'; }
      alert('Could not add to cart. Please try again.');
    });
  }

  // ─── Sticky ATC ───────────────────────────────────────────────────────────
  function initStickyAtc(el) {
    var btn = el.querySelector('[data-hs-sticky-add]');
    btn && btn.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToBuyBox();
    });
    el.addEventListener('click', function (e) {
      if (e.target.closest('button')) return;
      scrollToBuyBox();
    });

    var buyBox = activeBuyBox();
    if (!buyBox) return;
    function onScroll() {
      var r = buyBox.getBoundingClientRect();
      var atBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 200);
      var passed = r.bottom < 0;
      el.classList.toggle('is-visible', passed && !atBottom);
    }
    window.addEventListener('scroll', onScroll, {passive: true});
    onScroll();
  }

  // ─── Footer CTA ───────────────────────────────────────────────────────────
  function initFooterCta(el) {
    var btn = el.querySelector('[data-hs-footer-cta]');
    btn && btn.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToBuyBox();
    });
  }

  // Judge.me carousel review modal
  function initJudgeCarousel(el) {
    function prepareCompactReviews() {
      if (!el.classList.contains('hs-old-review-carousel')) return;
      el.querySelectorAll('.jdgm-carousel-item__review-body').forEach(function (bodyEl) {
        if (bodyEl.dataset.hsReviewPrepared === 'true') return;
        var fullText = bodyEl.textContent.replace(/\s+/g, ' ').trim();
        if (!fullText) return;
        bodyEl.dataset.hsFullReview = fullText;
        bodyEl.dataset.hsReviewPrepared = 'true';
        var excerpt = fullText;
        if (excerpt.length > 118) {
          excerpt = excerpt.slice(0, 118).replace(/\s+\S*$/, '').trim() + '...';
        }
        bodyEl.textContent = excerpt;
        bodyEl.style.setProperty('display', 'block', 'important');
        bodyEl.style.setProperty('height', '49px', 'important');
        bodyEl.style.setProperty('max-height', '49px', 'important');
        bodyEl.style.setProperty('overflow', 'hidden', 'important');
        bodyEl.style.setProperty('white-space', 'normal', 'important');
      });
    }

    prepareCompactReviews();
    window.setTimeout(prepareCompactReviews, 400);
    window.setTimeout(prepareCompactReviews, 1200);

    function ensureModal() {
      var modal = document.querySelector('[data-hs-review-modal]');
      if (modal) return modal;

      modal = document.createElement('div');
      modal.className = 'hs-review-modal';
      modal.setAttribute('data-hs-review-modal', '');
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML =
        '<div class="hs-review-modal-backdrop" data-hs-review-modal-close></div>' +
        '<div class="hs-review-modal-dialog" role="dialog" aria-modal="true" aria-label="Review">' +
          '<button class="hs-review-modal-close" type="button" data-hs-review-modal-close aria-label="Close review">×</button>' +
          '<div class="hs-review-modal-content" data-hs-review-modal-content></div>' +
        '</div>';
      document.body.appendChild(modal);

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-hs-review-modal-close]')) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });
      return modal;
    }

    function closeModal() {
      var modal = document.querySelector('[data-hs-review-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hs-review-modal-open');
    }

    function openModal(review) {
      var modal = ensureModal();
      var content = modal.querySelector('[data-hs-review-modal-content]');
      if (!content) return;

      var reviewRoot = review.querySelector('.jdgm-carousel-item__review, .jdgm-carousel-item__review-wrapper') || review;
      var titleEl = review.querySelector('.jdgm-carousel-item__review-title, .jdgm-rev__title');
      var bodyEl = review.querySelector('.jdgm-carousel-item__review-body, .jdgm-rev__body');
      var authorEl = review.querySelector('.jdgm-carousel-item__reviewer-name, .jdgm-rev__author');
      var dateEl = review.querySelector('.jdgm-carousel-item__timestamp, .jdgm-rev__timestamp');

      var title = titleEl ? titleEl.textContent.trim() : '';
      var body = bodyEl ? (bodyEl.dataset.hsFullReview || bodyEl.textContent).trim() : reviewRoot.textContent.trim();
      var author = authorEl ? authorEl.textContent.trim() : '';
      var date = dateEl ? dateEl.textContent.trim() : '';
      title = title.replace(/\s+/g, ' ');
      body = body.replace(/\s+/g, ' ').replace(/^★+\s*/, '');
      author = author.replace(/\s+/g, ' ');
      date = date.replace(/\s+/g, ' ');
      if (title && body.indexOf(title) === 0) body = body.slice(title.length).trim();
      if (author && body.lastIndexOf(author) > Math.max(0, body.length - author.length - 8)) {
        body = body.slice(0, body.lastIndexOf(author)).trim();
      }

      content.innerHTML = '';
      var shell = document.createElement('div');
      shell.className = 'hs-review-modal-card';
      var starsWrap = document.createElement('div');
      starsWrap.className = 'hs-review-modal-stars';
      starsWrap.textContent = '★★★★★';
      shell.appendChild(starsWrap);
      if (title) {
        var titleNode = document.createElement('h3');
        titleNode.textContent = title;
        shell.appendChild(titleNode);
      }
      if (body) {
        var bodyNode = document.createElement('p');
        bodyNode.textContent = body;
        shell.appendChild(bodyNode);
      }
      if (author || date) {
        var metaNode = document.createElement('div');
        metaNode.className = 'hs-review-modal-meta';
        metaNode.textContent = [author, date].filter(Boolean).join(' · ');
        shell.appendChild(metaNode);
      }
      content.appendChild(shell);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hs-review-modal-open');
      var close = modal.querySelector('[data-hs-review-modal-close]');
      close && close.focus();
    }

    el.addEventListener('click', function (e) {
      if (e.target.closest('.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow, .hs-judge-carousel-link')) return;
      var review = e.target.closest('.jdgm-carousel-item__review, .jdgm-carousel-item__review-wrapper, .jdgm-carousel-item');
      if (!review || !el.contains(review)) return;
      review = review.closest('.jdgm-carousel-item') || review;
      e.preventDefault();
      e.stopPropagation();
      openModal(review);
    }, el.classList.contains('hs-old-review-carousel'));
  }

  // ─── Boot ─────────────────────────────────────────────────────────────────
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    var liveBuyBox = activeBuyBox();
    document.querySelectorAll('[data-hs-init]').forEach(function (el) {
      var kind = el.getAttribute('data-hs-init');
      // Only the visible buy box drives the shared state / sticky ATC.
      if (kind === 'buy-box' && liveBuyBox && el !== liveBuyBox) return;
      try {
        if (kind === 'gallery')      initGallery(el);
        if (kind === 'buy-box')      initBuyBox(el);
        if (kind === 'marquee')      initMarquee(el);
        if (kind === 'before-after') initBeforeAfter(el);
        if (kind === 'faq')          initFaq(el);
        if (kind === 'video')        initVideo(el);
        if (kind === 'sticky-atc')   initStickyAtc(el);
        if (kind === 'footer-cta')   initFooterCta(el);
        if (kind === 'judge-carousel') initJudgeCarousel(el);
      } catch (error) {
        console.error('Hairstreaq component failed to initialize:', kind, error);
      }
    });
  });
})();
